import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import authReducer from "./auth";
import metaReducer from "./meta";
import calculatorReducer from "./calculator";
import investmentsReducer from "./investments";
import dashboardReducer from "./dashboard";
import coursesReducer from "./courses";

const store = configureStore({
  reducer: {
    auth: authReducer,
    meta: metaReducer,
    calculator: calculatorReducer,
    investments: investmentsReducer,
    dashboard: dashboardReducer,
    courses: coursesReducer,
  },
  devTools: false,
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
